class TooltipManager {
    constructor() {
        this.instances = new Map();
        this.init();
    }

    init() {
        const components = document.querySelectorAll('.tooltip-rte-block-component');
        components.forEach(component => this.createTooltip(component));
        this.bindGlobalEvents();
    }

    createTooltip(component) {
        const trigger = component.querySelector('.tooltip-trigger');
        const content = component.querySelector('.tooltip-content');
        
        if (!trigger || !content) return;

        const tooltip = new Tooltip(trigger, content);
        this.instances.set(component, tooltip);
    }

    hideAll() {
        this.instances.forEach(tooltip => tooltip.hide());
    }

    bindGlobalEvents() {
        document.addEventListener('click', (e) => {
            if (!e.target.closest('.tooltip-rte-block-component')) {
                this.hideAll();
            }
        });
    }
}

class Tooltip {
    constructor(trigger, content) {
        this.trigger = trigger;
        this.content = content;
        this.isOpen = false;
        this.setupAccessibility();
        this.bindEvents();
    }

    setupAccessibility() {
        this.trigger.setAttribute('role', 'button');
        this.trigger.setAttribute('tabindex', '0');
        this.trigger.setAttribute('aria-expanded', 'false');
        this.content.setAttribute('aria-hidden', 'true');
    }

    show() {
        if (this.isOpen) return;
        
        this.isOpen = true;
        this.content.style.display = 'block';
        this.trigger.setAttribute('aria-expanded', 'true');
        this.content.setAttribute('aria-hidden', 'false');
        
        this.position();
    }

    hide() {
        if (!this.isOpen) return;
        
        this.isOpen = false;
        this.content.style.display = 'none';
        this.trigger.setAttribute('aria-expanded', 'false');
        this.content.setAttribute('aria-hidden', 'true');
    }

    toggle() {
        this.isOpen ? this.hide() : this.show();
    }

    position() {
        const triggerRect = this.trigger.getBoundingClientRect();
        const viewportWidth = window.innerWidth;
        
        // Temporarily show content to measure it
        const wasHidden = this.content.style.display === 'none';
        if (wasHidden) {
            this.content.style.display = 'block';
            this.content.style.visibility = 'hidden';
        }
        
        const tooltipWidth = this.content.getBoundingClientRect().width;
        
        if (wasHidden) {
            this.content.style.visibility = '';
            this.content.style.display = 'none';
        }
        
        const spaceOnRight = viewportWidth - triggerRect.right;
        
        this.content.classList.remove('tooltip-left', 'tooltip-right');
        this.content.classList.add(spaceOnRight >= tooltipWidth + 16 ? 'tooltip-right' : 'tooltip-left');
    }

    bindEvents() {
        this.trigger.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.toggle();
        });
        
        this.trigger.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                this.toggle();
            } else if (e.key === 'Escape') {
                this.hide();
            }
        });
    }
}

// Initialize tooltip manager
const tooltipManager = new TooltipManager();
